import { render, staticRenderFns } from "./DoubleInput.vue?vue&type=template&id=2e86b9c7&scoped=true&"
import script from "./DoubleInput.vue?vue&type=script&lang=ts&"
export * from "./DoubleInput.vue?vue&type=script&lang=ts&"
import style0 from "./DoubleInput.vue?vue&type=style&index=0&id=2e86b9c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e86b9c7",
  null
  
)

export default component.exports